import React from "react";
import { Modal } from "antd";

const StockWarningModal = ({ visible, notFoundImg }) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      zIndex={2000}
      style={{
        textAlign: "center",
        width: "150px",
        height: "70vh",
      }}
      styles={{ body: {
        padding: 0,
      } }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "500",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: 0,
          fontSize: "1vw",
        }}
      >
        <img src={notFoundImg} alt="Stock Unavailable" style={{ width: "120px", height: "100px", marginBottom: "5px", marginTop: "10px" }} />
        <p style={{ margin: "5px 0", fontSize: "2em", fontWeight: "600", color: "#0F0718" }}>Stock is not available</p>
        <hr style={{ width: "70%", color: "rgba(146,144,152,0.5)" }} />
        <p
          style={{
            color: "#0F0718",
            fontWeight: 400,
            fontSize: "1.25em",
            padding: "15px 15px 0 15px",
          }}
        >
          The item is not available in stock.
        </p>
      </div>
    </Modal>
  );
};

export default StockWarningModal;
